import React from 'react';
import "../styles/App.scss";
import "../styles/PagesStyles.scss"

const DEFAULT_PLAYER = "/assets/images/recordPlayer-soundOff.png";
const SOUNDON_PLAYER = "/assets/images/recordPlayer-soundOn.png";

function RecordPlayer(props){
    const {soundState, altText} = props
    const imgToUse = soundState ? SOUNDON_PLAYER : DEFAULT_PLAYER;
    return(
        <>
            <div className="App-footer">
                <img className="App-recordplayer" src={imgToUse} alt={altText}/>
            </div>
        </>
    );
}
export default RecordPlayer;